import Vue from "vue";
import {Context} from "horizon-js-front-sdk/lib/Context";

export abstract class DestructableView extends Vue{

    static setCurrentAppView(view : DestructableView){
        Context.getGlobalContextStorage()['currentAppView'] = view;
    }
    static getCurrentAppView() : DestructableView{
        return typeof Context.getGlobalContextStorage()['currentAppView'] === 'undefined' ? null : Context.getGlobalContextStorage()['currentAppView'];
    }

    constructor(data:any){
        super(data);
        DestructableView.setCurrentAppView(this);
    }

    /**
     * @returns {Promise<boolean>} return true if continue to redirect, false to cancel redirection
     */
    destruct() : Promise<void>{
        return Promise.resolve();
    }


}
